import React, { Component } from "react";
import { Grid, Typography, TextField } from "@material-ui/core";
import { Formik, Form } from "formik";
import * as yup from "yup";
import axios from "axios";
import { connect } from "react-redux";
import { showSnackbar } from "../../actions";
import { serverUrl } from "../../utils";

class InventoryInterest extends Component {
  state = { success: false };

  handleSubmit = async (values) => {
    try {
      const res = await axios.post(
        `${serverUrl}/api/v1/interest/owner`,
        values
      );
      this.setState({
        success: res.data,
      });
    } catch (e) {
      this.props.showSnackbar(
        (e.response && e.response.data) || e.message,
        "error",
        null,
        null,
        JSON.stringify(e)
      );
    }
  };

  render() {
    const { success } = this.state;
    return (
      <Grid container style={{ backgroundColor: "#322e2e", color: "white" }}>
        <Grid item sm={3} />
        {success ? (
          <Grid item xs={12} sm={6} justifyContent="center">
            <Typography variant="h5" align="center">
              Thank you!
            </Typography>
          </Grid>
        ) : (
          <>
            <Grid
              item
              xs={12}
              sm={6}
              style={{
                justifyItems: "center",
                display: "flex",
                flexDirection: "column",
                padding: "24px",
              }}
            >
              <Typography variant="h4" align="center" gutterBottom>
                Don&apos;t see what you&apos;re
                <br /> looking for?
              </Typography>
              <Formik
                initialValues={{ email: "", suggestion: "" }}
                onSubmit={this.handleSubmit}
                validationSchema={yup
                  .object()
                  .shape({ email: yup.string().required("Required field") })}
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <Grid container justifyContent="center">
                      <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography align="center">
                          Sign up and we&apos;ll notify you as our <br />
                          inventory grows.
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="normal"
                          fullWidth
                          variant="filled"
                          name="email"
                          onChange={handleChange}
                          InputProps={{
                            style: { backgroundColor: "white" },
                          }}
                          onBlur={handleBlur}
                          label="Email"
                          helperText={
                            !!touched.email && !!errors.email && errors.email
                          }
                          FormHelperTextProps={{
                            error: true,
                          }}
                          value={values.email}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          align="center"
                          style={{ marginTop: "16px" }}
                        >
                          (optional)
                          <br />
                          Tell us what you&apos;d like to see.
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          multiline
                          variant="filled"
                          InputProps={{
                            style: { backgroundColor: "white" },
                          }}
                          margin="normal"
                          fullWidth
                          name="suggestion"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label="Product suggestion"
                          value={values.suggestion}
                        />
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <button
                          type="submit"
                          className="btn btn-skipti-orange"
                          style={{ width: "100%", marginTop: "16px" }}
                        >
                          Submit
                        </button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
          </>
        )}
        <Grid item sm={3} />
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  showSnackbar,
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryInterest);
